export type InternalRoutes = 'BookingList' | 'BookingDetails' | 'Bookingscreditflight' | 'Home' | 'Auth';
export const internalRoutes: Record<InternalRoutes, string> = {
  BookingList: '/bookinglist',
  BookingDetails: '/booking',
  Bookingscreditflight: '/bookingcreditflight',
  Home: '/home',
  Auth: '/auth'
};
